import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectInputTypeFilter } from 'shared/selectors/advancedFilters';
import { selectInputType } from 'shared/selectors/jsonQuery';
import { buildEntranceInputType, parseEntranceState } from 'shared/utils/entranceInputType';
import { EEntranceType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const InputTypeContainer: FC = () => {
  const { label, options } = useSelector(selectInputTypeFilter);
  const inputType = useSelector(selectInputType);
  const { directions, isSeparate } = parseEntranceState(inputType);

  const onChange = useFilterChangeCallback();

  const applyInputType = useCallback(
    (nextDirections: readonly EEntranceType[], nextIsSeparate: boolean) => {
      onChange({
        action: 'setInputType',
        arguments: [buildEntranceInputType(nextDirections, nextIsSeparate) as NonEmptyArray<EEntranceType> | null],
      });
    },
    [onChange],
  );

  const handleInputTypeChange = useCallback(
    (newValue: NonEmptyArray<EEntranceType> | null) => {
      applyInputType(newValue ?? [], isSeparate);
    },
    [applyInputType, isSeparate],
  );

  const handleIsSeparatedInputTypeChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      applyInputType(directions, checked);
    },
    [applyInputType, directions],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter>
          <MultiSelectionAdvancedFilter
            value={directions.length > 0 ? directions : [null]}
            options={options}
            onFilterChange={handleInputTypeChange}
          />
        </InlineFilter>
        <InlineFilter>
          <Checkbox label="Отдельный вход" checked={isSeparate} onChange={handleIsSeparatedInputTypeChange} />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
